import React, { useState } from 'react';

import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { connect } from 'react-redux';
import CreateCommissionReportAffiliatePresentational from './create-commision-report-affiliate-presentational';
import { Col } from 'antd';

const CreateCommissionReportAffiliateFunctional = ({ userDetails }) => {
	const [comments, setComments] = useState([]);
	const columns = [
		{
			title: 'Company Name',
			dataIndex: 'company',
			key: 'company',
			// sorter: (a, b) => a.company.localeCompare(b.company),
		},
		{
			title: 'Customer',
			dataIndex: 'customer',
			align: 'left',
			// sorter: (a, b) => a.customer.localeCompare(b.customer),
			key: 'customer',
		},
		{
			title: 'Order',
			dataIndex: 'order',
			key: 'order',
			align: 'left',
			// sorter: (a, b) => a.order.localeCompare(b.order),
		},
		{
			title: 'Product',
			dataIndex: 'product',
			align: 'left',
			// sorter: (a, b) => a.product.localeCompare(b.product),
			key: 'product',
		},
		{
			title: 'Product Price',
			dataIndex: 'totalPrice',
			align: 'left',
			// sorter: (a, b) => a.totalPrice.localeCompare(b.totalPrice),
			key: 'totalPrice',
		},
		{
			title: 'Commission %',
			dataIndex: 'commission',
			align: 'left',
			// sorter: (a, b) => a.commission.localeCompare(b.commission),
			key: 'commission',
		},
		{
			title: 'commission Amount',
			dataIndex: 'commissionAmount',
			align: 'left',
			// sorter: (a, b) => a.commissionAmount - b.commissionAmount,
			key: 'commissionAmount',
			render: (value) => <Col> $ {value}</Col>,
		},
		// {
		// 	title: '',
		// 	dataIndex: 'title',
		// 	key: 'title',
		// 	render: () => {
		// 		return (
		// 			<Row>
		// 				<Col className="action_square_edit" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<EditOutlined />{' '}
		// 				</Col>
		// 				<Col className="action_square_transfer" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<SwapOutlined />
		// 				</Col>
		// 				<Col className="action_square_delete" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<DeleteOutlined />{' '}
		// 				</Col>
		// 			</Row>
		// 		);
		// 	},
		// },
	];

	const dataSource = [
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commission: '10%',
			totalPrice: '$12345',
			commissionAmount: 600,
		},
		{
			company: '3',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 900,
			commission: '10%',
			totalPrice: '$12345',
		},
	];

	const [state, setState] = useState({
		loading: false,
	});

	const valueChange = (key, value) => {
		let temp = comments.map((comment) => {
			if (comment.key === key) {
				return {
					...comment,
					value,
				};
			} else return comment;
		});
		setComments([...temp]);
	};

	const addComments = () => {
		console.log([
			...comments,
			{
				key: comments.length,
				value: '',
			},
		]);
		setComments([
			...comments,
			{
				key: comments.length,
				value: '',
			},
		]);
	};

	const removeComment = (key) => {
		let temp = comments.filter((comment) => comment.key !== key);
		console.log(temp);
		setComments([...temp]);
	};

	const handleSetState = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};
	return (
		<CreateCommissionReportAffiliatePresentational
			columns={columns}
			dataSource={dataSource}
			handleSetState={handleSetState}
			state={state}
			userDetails={userDetails}
			addComments={addComments}
			removeComment={removeComment}
			valueChange={valueChange}
			comments={comments}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const Connected = connect(mapStateToProps, null)(CreateCommissionReportAffiliateFunctional);

export default Connected;
